import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Card,
  Tabs,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import TextField from '../../../v2/MUI_custom_component/TextField';
import {
  addManufacturerRoleToExistingFirmAction,
  getBuyerRolesAction,
} from '../../../v2/Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import { searchByTypes } from '../../../utils/settings';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import StatusChip from '../../../v2/MUI_custom_component/chips/StatusChip';
import StandardChip from '../../../v2/MUI_custom_component/chips/StandardChip';
import { toast } from 'react-toastify';
import CustomTab from '../../../v2/MUI_custom_component/Tab/CustomTab';
import HumbeeModal from '../../../v2/MUI_custom_component/Modal/HumbeeModal';
import DisclaimerSvg from '../../Illustrration/components/DisclaimerSvg';
import { AddFirmSvg } from "../../Illustrration/components/AddFirmSvg";
import CustomButton from '../../../v2/MUI_custom_component/Button/CustomButton';
import SelectRoleModal from '../../Common/SelectRoleModal';
import SearchResultTable from "../../Inventory/components/SearchResultTable";
import { toCapitalized } from '../../../v2/Utils/Capitalize';
import {
  getUserInventoryTransactionsStpInfoAction,
} from '../../../screen/distributor/action/util_action';
import { CustomRadioGroup } from '../../../v2/MUI_custom_component/Radio';
import { SearchOutlined } from '../../../components/icons';
import { searchCompanyAction } from '../../../v2/APIs/action';
import { isValidEntityId } from '../../Common/Entity/actions/reduxActions';

const STPSelectionBase = ({
  pageType = 'inventory',
  title = 'Shipping Info',
  saveButtonLabel = 'Save',
  navigationPaths = {
    checkout: '/inventory/checkout',
    selectedShipToParty: '/inventory/selected-ship-to-party',
    onboardBuyer: '/onboard-buyer',
    buyerRolesParam: {
        is_ship_to_party: false,
        is_sell_to_buyer: true,
      },
  },
}) => {
  const [CompanyRoleData, setCompanyRoleData] = useState([]);
  const [influencerRoles, setInfluencerRoles] = useState([]);
  const [influencerRolesExists, setInfluencerRolesExists] = useState(false);
  const [influencerTabSelected, setInfluencerTabSelected] = useState(false);
  const [openSelectRolesPrompt, setOpenSelectRolesPrompt] = useState(false);
  const [promptDetails, setPromptDetails] = useState({});
  const [activeTab, setActiveTab] = useState('My Network');
  const [loading, setLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');
  const [userType, setUserType] = useState({});
  const [allBuyers, setAllBuyers] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width:1200px)');
  const IS_SELL_TO_BUYER = navigationPaths.buyerRolesParam.is_sell_to_buyer;
  const IS_SHIP_TO_PARTY = navigationPaths.buyerRolesParam.is_ship_to_party;

  const [isLoadingAllBuyers, setIsLoadingAllBuyers] = useState(false);
  const [activeRadio, setActiveRadio] = useState(searchByTypes['PHONE']);
  const [enteredValue, setEnteredValue] = useState('');
  const [allFoundCompanies, setAllFoundCompanies] = useState([]);
  const [onboardPrompt, setOnboardPrompt] = useState({
    open: false,
    message: '',
  });
  const [influencerPrompt, setInfluencerPrompt] = useState({
    open: false,
    data: null,
    mode: null, // 'checkout' | 'addRoles'
  });
  const [vcpPrompt, setVcpPrompt] = useState({
    open: false,
    data: null,
    mode: null, // 'club' (MRM) | 'direct' (setUser → selected-ship-to-party)
  });
  const [selectedUser, setSelectedUser] = useState(null);
  const [errors, setErrors] = useState({});

  const {   loginUser, noDownwardChain } =
    useSelector((state) => {
      return {
        loginUser: state.loginReducer.loginUser,
        noDownwardChain: state.bcmOrderReducer.noDownwardChain,
      };
    });
    const { selectedSupplier: selectedCompany, selectedEntity: selectedCompanyEntity } = useSelector(
        (state) => state.entityReducer
    )

  const getRoles = async () => {
    if (!isValidEntityId(selectedCompany)) {
      return;
    }
    const { data, error, message } = await getBuyerRolesAction(
      selectedCompany,
      IS_SHIP_TO_PARTY,
      IS_SELL_TO_BUYER,
    );
    if (!error) {
      if (data.roles.length === 1 && data.roles[0].display_name === 'SELF') {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: true,
        });
      } else {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: false,
        });
      }

      const influencerRoles = data.roles.filter(({ region_role_id }) => {
        return region_role_id === null;
      });

      setInfluencerRoles(influencerRoles);

      const companyRoles = data.roles.filter(({ region_role_id }) => region_role_id !== null);
      
      if (influencerRoles?.length > 0) {
        setInfluencerRolesExists(true);
        setInfluencerTabSelected(true);
        setSelectedRole('Influencer');
      } else {
        setInfluencerRolesExists(false);
        if (companyRoles.length > 0) {
          const firstRole = companyRoles[0];
          setSelectedRole(firstRole.display_name);
          setUserType({
            firm_role_id: firstRole.firm_role_id,
            firm_role_name: firstRole.display_name,
          });
        }
      }

      setCompanyRoleData(companyRoles);
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    selectedCompany && getRoles();
  }, [selectedCompany]);

  const getAggShilpkarDetailsByBuyer = async (userType) => {
    setIsLoadingAllBuyers(true);

    const firm_role_ids = (
      influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [userType.firm_role_id]
    ).filter((id) => id !== null && id !== undefined);

    if (firm_role_ids.length === 0 || !isValidEntityId(selectedCompany)) {
      setIsLoadingAllBuyers(false);
      return;
    }
    const payload = {
      firm_role_ids,
      supplier_id: Number(selectedCompany),
    };

    const { data, error } = await getUserInventoryTransactionsStpInfoAction(
      payload,
    );
    setIsLoadingAllBuyers(false);
    if (!error) {
      setAllBuyers(data);
      setOriginalBuyersData(data);

      const hasActive = data.some(
        (section) => section.display_name === 'ACTIVE',
      );
      const hasDormant = data.some(
        (section) => section.display_name === 'DORMANT',
      );

      if (
        (hasActive || hasDormant) &&
        !data.find((section) => section.display_name === activeTab) &&
        activeTab !== 'My Network'
      ) {
        setActiveTab('My Network');
      }
    }
  };

  const searchByPhone = Number(activeRadio) === searchByTypes['PHONE'];
  const searchByName = Number(activeRadio) === searchByTypes['NAME'];
  const searchByPan = Number(activeRadio) === searchByTypes['PAN'];
  const searchByGst = Number(activeRadio) === searchByTypes['GST'];

  const searchInTableData = (searchValue) => {
    if (!searchValue || searchValue.trim() === '' || searchValue.length < 2) {
      return [];
    }
    if (!allBuyers || allBuyers.length === 0) return [];
    let foundResults = [];
    allBuyers.forEach((section) => {
      if (section.data && section.data.length > 0) {
        const filteredData = section.data.filter((row) => {
          if (searchByPhone) {
            return row.company_phone_number?.includes(searchValue);
          } else if (searchByName) {
            return row.company_name
              ?.toLowerCase()
              .includes(searchValue.toLowerCase());
          } else if (searchByPan) {
            return (
              row.company_pan
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              row.pancard_no?.toLowerCase().includes(searchValue.toLowerCase())
            );
          } else if (searchByGst) {
            return (
              row.company_gstin
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              row.gstin?.toLowerCase().includes(searchValue.toLowerCase())
            );
          }
          return false;
        });

        if (filteredData.length > 0) {
          foundResults.push({
            ...section,
            data: filteredData,
          });
        }
      }
    });
    return foundResults;
  };

  const performSearch = async (value) => {
    if (!value || value.trim() === '' || value.length === 0) {
      resetTableData();
      setAllFoundCompanies([]);
      return;
    }

    const tableResults = searchInTableData(value);
    if (tableResults.length > 0) {
      setAllBuyers(tableResults);
      return;
    }
    const hasMyNetwork = allBuyers.some(
      (section) => section.display_name === 'My Network',
    );

    if (hasMyNetwork) {
      setAllBuyers(
        allBuyers.map((section) =>
          section.display_name === 'My Network'
            ? { ...section, data: [] }
            : section,
        ),
      );
    } else {
      setAllBuyers([{ display_name: 'My Network', data: [] }]);
    }

    if (searchByPhone) {
      if (value.length === 10 && /^\d{10}$/.test(value)) {
        setErrors({ ...errors, phone: null });
        await searchUserByInfo(value);
      } else if (value.length !== 10) {
        setErrors({
          ...errors,
          phone: 'Please enter a valid 10 digit mobile number',
        });
      }
    } else {
      setErrors({ ...errors, phone: null });
      await searchUserByInfo(value);
    }
  };

  useEffect(() => {
    if (!userType) return;
    if (!influencerTabSelected && !isValidEntityId(userType.firm_role_id)) return;
    getAggShilpkarDetailsByBuyer(userType);
  }, [userType]);

  useEffect(() => {
    if (influencerTabSelected && influencerRoles.length > 0) {
      getAggShilpkarDetailsByBuyer({});
    }
  }, [influencerTabSelected, influencerRoles]);

  useEffect(() => {
    if (allBuyers && allBuyers.length > 0) {
      setActiveTab('My Network');
    }
  }, [allBuyers]);

  const addUserToManufacturer = async (company_id, role, rowData) => {
    setOpenSelectRolesPrompt(false);
    setEnteredValue('');

    const payload = {
      manufacturer_id: role?.manufacturer_id || Number(selectedCompany),
      firm_role_id: role?.firm_role_id,
      region_role_map_id: role?.region_role_id,
      company_id: company_id,
    };

    const { data, error, message } =
      await addManufacturerRoleToExistingFirmAction(payload);

    if (!error) {
      setAllFoundCompanies([]);
      setEnteredValue('');

      const phone = rowData?.phone_no || rowData?.company_phone_number;

      if (!influencerTabSelected) {
        const vcpRole = CompanyRoleData.find(
          (r) => r.firm_role_id === userType?.firm_role_id,
        );
        const approvalRequired =
          !!vcpRole?.onboarding_config?.is_supplier_approval_required;

        if (approvalRequired) {
          const gi = rowData?.geographic_info;
          const buyerDetails = {
            company_name: rowData?.name,
            company_id: rowData?.id,
            company_phone_no:
              rowData?.phone_no || rowData?.company_phone_number,
            user_esi_id:
              rowData?.esi_info_with_operational_address?.[0]?.esi_info
                ?.esi_id ?? null,
            company_address1: gi?.address_info?.address_line_1 || '',
            company_address2: gi?.address_info?.address_line_2 || '',
            company_address3: gi?.address_info?.address_line_3 || '',
            company_pincode: gi?.pincode_info?.pincode_id ?? null,
            district_id: gi?.district_info?.district_id ?? null,
            location_id: gi?.location_info?.location_id ?? null,
            location_name: gi?.location_info?.location_name || '',
            pricing_geography_id:
              gi?.pricing_geography_info?.pricing_geography_id ?? null,
            pricing_geography_name:
              gi?.pricing_geography_info?.pricing_geography_name || '',
            state_id: gi?.state_info?.state_id ?? null,
            pancard_no:
              rowData?.gstin_pan && rowData.gstin_pan.length === 10
                ? rowData.gstin_pan
                : null,
            gstin:
              rowData?.gstin_pan && rowData.gstin_pan.length === 15
                ? rowData.gstin_pan
                : null,
            esi_info_with_operational_address:
              rowData?.esi_info_with_operational_address,
          };

          return navigate('/onboard-buyer-success', {
            state: {
              isInfluencer: false,
              isSupplierApprovalRequired: true,
              origin: 'dp_stp',
              message,
              role: toCapitalized(selectedRole),
              billInfo: buyerDetails,
            },
          });
        }

        if (phone) return searchUserByInfo(phone, true);
        return;
      }

      toast.success(message);
      if (phone) return searchUserByInfo(phone, true);
      return;
    } else {
      return toast.error(message);
    }
  };

  const searchUserByInfo = async (value, isExistingUser, selfRole) => {
    const firm_role_ids = (
      influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [selfRole ? selfRole.firm_role_id : userType.firm_role_id]
    ).filter((id) => id !== null && id !== undefined);

    if (firm_role_ids.length === 0 || !isValidEntityId(selectedCompany)) {
      return;
    }
    const payload = {
      supplier_id: Number(selectedCompany),
      firm_role_ids,
    };

    if (isExistingUser) {
      payload.company_phone = value;
    } else {
      if (searchByPhone) payload.company_phone = value;
      if (searchByName) payload.company_name = value;
      if (searchByPan) payload.company_pan = value;
      if (searchByGst) payload.company_gstin = value;
    }
    setLoading(true);
    const { data, error, message } = await searchCompanyAction(payload);
    setLoading(false);
    if (!error) {
      if (
        data.length === 1 &&
        !data[0]?.onboarding_required &&
        isExistingUser
      ) {
        return setUser(data[0], selfRole ? 'Self' : undefined);
      } else if (data.length === 1 && data[0]?.onboarding_required) {
        setAllFoundCompanies([]);
        return setOnboardPrompt({
          open: true,
          message: data[0].prompted_message,
        });
      } else {
        setAllFoundCompanies(
          data.map((vv) => ({
            label: vv.name,
            value: vv.id,
            ...vv,
          })),
        );
      }
    } else return toast.error(message);
  };

  const debouncedSearch = useDebouncedCallback((value) => {
    setAllFoundCompanies([]);
    if (value.length === 0) {
      resetTableData();
      return;
    }

    performSearch(value);
  }, 1000);

  const [originalBuyersData, setOriginalBuyersData] = useState([]);

  const resetTableData = () => {
    if (originalBuyersData.length > 0) {
      setAllBuyers(originalBuyersData);
    }
    setAllFoundCompanies([]);
    if (debouncedSearch && debouncedSearch.cancel) {
      debouncedSearch.cancel();
    }
  };

  const checkVCPClubbingLogic = (data) => {
    const { role_details } = data;

    if (!role_details?.auto_create_mrm) {
      if (!influencerTabSelected) {
        if (!data?.prompted_message?.trim()) return setUser(data);
        return setVcpPrompt({ open: true, data, mode: 'direct' });
      }
      return setUser(data);
    } else if (role_details?.auto_create_mrm && role_details?.firm_role_id) {
      return setVcpPrompt({ open: true, data, mode: 'club' });
    } else if (role_details?.auto_create_mrm && !role_details?.firm_role_id) {
      return setInfluencerPrompt({ open: true, data, mode: 'addRoles' });
    } else return toast.error(data.error_message);
  };

  const setUser = (data, roleNameOverride, { forceCheckout = false } = {}) => {
    const effectiveRole = roleNameOverride ?? selectedRole;
    const {
      geographic_info: {
        address_info,
        pincode_info,
        district_info,
        state_info,
        pricing_geography_info,
        location_info,
      },
      esi_info_with_operational_address,
    } = data;

    const userObj = {
      company_name: data.name,
      company_id: data.id,
      company_phone_no: data.phone_no,
      user_esi_id: data.esi_id,
      company_address1: address_info.address_line_1,
      company_address2: address_info.address_line_2,
      company_address3: address_info.address_line_3,
      company_pincode: pincode_info.pincode_id,
      district_id: district_info.district_id,
      location_id: location_info.location_id,
      location_name: location_info.location_name,
      pricing_geography_id: pricing_geography_info.pricing_geography_id,
      pricing_geography_name: pricing_geography_info.pricing_geography_name,
      state_id: state_info.state_id,
      pancard_no:
        data.gstin_pan && data.gstin_pan.length === 10 && data.gstin_pan,
      gstin: data.gstin_pan && data.gstin_pan.length === 15 && data.gstin_pan,
      esi_info_with_operational_address
    };

    if (influencerTabSelected || forceCheckout) {
      navigate(navigationPaths.checkout, {
        state: {
          bill_info: userObj,
          influencerTabSelected: true,
          selectedRole: toCapitalized(effectiveRole),
        },
      });
    } else {
      navigate(navigationPaths.selectedShipToParty, {
        state: {
          buyerDetails: userObj,
          influencerTabSelected: influencerTabSelected,
          selectedRole: toCapitalized(effectiveRole),
        },
      });
    }
  };

  const handleExistingShipToPartyClick = (row) => {
    setSelectedUser(row);
  };

  const notFoundAction = () => {
    setOnboardPrompt({ open: false, message: '' });
    return navigate(navigationPaths.onboardBuyer, {
      state: {
        presetInfluencer: influencerTabSelected,
        preselectFirmRoleId: influencerTabSelected
          ? null
          : userType?.firm_role_id,
        mobileNumber: enteredValue,
        origin: 'dp_stp',
        selectedRole: toCapitalized(selectedRole),
      },
    });
  };

  const getCurrentTabData = () => {
    if (!allBuyers || allBuyers.length === 0) return null;

    const currentTabData = allBuyers.find(
      (section) => section.display_name === activeTab,
    );

    if (
      currentTabData &&
      currentTabData.data &&
      currentTabData.data.length > 0
    ) {
      return currentTabData;
    }

    if (activeTab === 'My Network' || !currentTabData) {
      const activeSection = allBuyers.find(
        (section) => section.display_name === 'ACTIVE',
      );
      const dormantSection = allBuyers.find(
        (section) => section.display_name === 'DORMANT',
      );

      if (activeSection && dormantSection) {
        return {
          display_name: 'My Network',
          data: [...(activeSection.data || []), ...(dormantSection.data || [])],
        };
      } else if (activeSection) {
        return {
          display_name: 'My Network',
          data: [...(activeSection.data || [])],
        };
      } else if (dormantSection) {
        return {
          display_name: 'My Network',
          data: [...(dormantSection.data || [])],
        };
      } else if (allBuyers.length > 0) {
        let combinedData = [];
        allBuyers.forEach((section) => {
          if (section.data && section.data.length > 0) {
            combinedData = [...combinedData, ...section.data];
          }
        });

        if (combinedData.length > 0) {
          return {
            display_name: 'My Network',
            data: combinedData,
          };
        }
      }
    }

    if (allBuyers.length > 0) {
      const firstTabWithData = allBuyers.find(
        (section) => section.data && section.data.length > 0,
      );
      if (firstTabWithData) {
        return firstTabWithData;
      }
    }

    return currentTabData || { display_name: activeTab, data: [] };
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          p: { xs: 2, md: 0 },
          mr: { xs: 0, md: 4 },
          position: { xs: "fixed", md: "relative" },
          top: { xs: "88px", md: 0 },
          left: { xs: 0, md: "auto" },
          right: { xs: 0, md: "auto" },
          zIndex: { xs: 1000, md: "auto" },
          zIndex: 1000,
          boxShadow: { xs: "0px 2px 8px 0px #0000001A", md: "none" },
          background: { xs: "#FAFAFA", md: "transparent" },
          pb: 0,
        }}>
        <CustomButton
          variant="filled"
          color="primary"
          label={loading ? "Saving..." : saveButtonLabel}
          disabled={!selectedUser || loading}
          sx={{ width: { xs: "100%", sm: "auto" } }}
          onClick={() => {
            searchUserByInfo(selectedUser.company_phone_number, true);
          }}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
        />
      </Box>
      <Box
        sx={{
          mt: { xs: "72px", md: 0 },
          p: { xs: 2, md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}>
        <Typography variant="h2">{title}</Typography>
        <SelectRoleModal
          allInfluencerRoles={influencerRoles}
          visible={openSelectRolesPrompt}
          onClose={() => {
            setOpenSelectRolesPrompt(false);
            setEnteredValue("");
          }}
          promptDetails={promptDetails}
          onFinish={(id, role) => addUserToManufacturer(id, role, promptDetails)}
        />
        <HumbeeModal
          open={onboardPrompt.open}
          onClose={() => setOnboardPrompt({ open: false, message: "" })}
          onConfirm={notFoundAction}
          illustration={<DisclaimerSvg />}
          title={(onboardPrompt.message || "").split(",")[0]?.trim()}
          subtitle={(onboardPrompt.message || "")
            .split(",")
            .slice(1)
            .join(",")
            .trim()}
          cancelLabel="Cancel"
          confirmLabel="Onboard Buyer"
        />
        <HumbeeModal
          open={influencerPrompt.open}
          onClose={() =>
            setInfluencerPrompt({ open: false, data: null, mode: null })
          }
          onConfirm={() => {
            const d = influencerPrompt.data;
            const mode = influencerPrompt.mode;
            setInfluencerPrompt({ open: false, data: null, mode: null });
            if (mode === 'addRoles') {
              setPromptDetails(d);
              setOpenSelectRolesPrompt(true);
            } else {
              setUser(d);
            }
          }}
          illustration={<AddFirmSvg />}
          title="Continue as Influencer?"
          subtitle={influencerPrompt.data?.prompted_message}
          cancelLabel="Cancel"
          confirmLabel="Yes"
        />
        <HumbeeModal
          open={vcpPrompt.open}
          onClose={() =>
            setVcpPrompt({ open: false, data: null, mode: null })
          }
          onConfirm={() => {
            const d = vcpPrompt.data;
            const mode = vcpPrompt.mode;
            setVcpPrompt({ open: false, data: null, mode: null });
            if (mode === 'club') {
              addUserToManufacturer(d?.id, d?.role_details, d);
            } else {
              setUser(d);
            }
          }}
          illustration={<AddFirmSvg />}
          title={`Continue as ${toCapitalized(selectedRole)}?`}
          subtitle={vcpPrompt.data?.prompted_message}
          cancelLabel="Cancel"
          confirmLabel="Yes"
        />
        <Card
          sx={{
            padding: { xs: 2, sm: 2 },
            borderRadius: 2,
            boxShadow: "none",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1, md: 1 },
            }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 1, md: 1 },
              }}>
              <Typography variant="labelD">Select Role</Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {CompanyRoleData.map((role) => {
                  const isSelected =
                    role.firm_role_id === userType.firm_role_id;
                  return (
                    <StandardChip
                      key={role.firm_role_id}
                      label={role.display_name}
                      size={isMobile ? "small" : "medium"}
                      selected={isSelected}
                      onClick={async () => {
                        setAllFoundCompanies([]);
                        setEnteredValue("");
                        setSelectedUser(null);
                        if (role.display_name?.toUpperCase() === "SELF") {
                          setSelectedRole("Self");
                          await searchUserByInfo(
                            loginUser.phone_no,
                            true,
                            role,
                          );
                        } else {
                          setInfluencerTabSelected(false);
                          setSelectedRole(role.display_name);
                          setUserType({
                            firm_role_id: role.firm_role_id,
                            firm_role_name: role.display_name,
                          });
                        }
                      }}
                      // sx={{ mr: 1}}
                    />
                  );
                })}

                {influencerRolesExists && (
                  <StandardChip
                    label="Influencer"
                    size={isMobile ? "small" : "medium"}
                    selected={influencerTabSelected}
                    onClick={() => {
                      setInfluencerTabSelected(true);
                      setUserType({});
                      setSelectedUser(null);
                      setSelectedRole("Influencer");
                    }}
                    sx={{ mr: 1 }}
                  />
                )}
              </Box>
            </Box>
            {!noDownwardChain &&
              (Object.keys(userType).length > 0 || influencerTabSelected) && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 1, md: 1 },
                  }}>
                  {/* CustomRadioGroup replaces MUI RadioGroup/FormControlLabel/Radio */}
                  <CustomRadioGroup
                    name="radio-buttons-group"
                    value={activeRadio}
                    row
                    size={isMobile ? "small" : "medium"}
                    onChange={(e) => {
                      setActiveRadio(e.target.value);
                      setAllFoundCompanies([]);
                      setEnteredValue("");
                      setSelectedUser(null);
                      setErrors({ ...errors, phone: null });
                      resetTableData();
                    }}
                    options={[
                      { value: searchByTypes["PHONE"], label: "Mobile Number" },
                      ...(!influencerTabSelected
                        ? [
                            { value: searchByTypes["NAME"], label: "Name" },
                            { value: searchByTypes["PAN"], label: "PAN" },
                            { value: searchByTypes["GST"], label: "GST" },
                          ]
                        : []),
                    ]}
                  />
                  <TextField
                    fullWidth
                    placeholder={`Search by ${
                      searchByPhone
                        ? "Mobile Number"
                        : searchByName
                          ? "Name"
                          : searchByPan
                            ? "PAN"
                            : searchByGst
                              ? "GST"
                              : ""
                    }`}
                    variant="outlined"
                    // sx={{ mb: 0.5 }}
                    value={enteredValue || ""}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchOutlined width={20} height={20} />
                          </InputAdornment>
                        ),
                      },
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      let regex;

                      if (value === "") {
                        setEnteredValue("");
                        setSelectedUser(null);
                        resetTableData();
                        setAllFoundCompanies([]);
                        setErrors({ ...errors, phone: null });
                        debouncedSearch.cancel();
                        return;
                      }

                      if (searchByPhone) {
                        regex = /^[0-9]{0,10}$/;
                        if (value.length <= 10 && regex.test(value)) {
                          setEnteredValue(value);
                          if (errors.phone) {
                            setErrors({ ...errors, phone: null });
                          }
                          if (value.length >= 2) {
                            debouncedSearch(value);
                          } else {
                            resetTableData();
                            setAllFoundCompanies([]);
                          }
                        }
                      } else if (searchByName) {
                        setEnteredValue(value);
                        if (value.length >= 3) {
                          debouncedSearch(value);
                        } else {
                          resetTableData();
                          setAllFoundCompanies([]);
                        }
                      } else if (searchByPan) {
                        regex = /^[a-zA-Z0-9]{0,10}$/;
                        if (value.length <= 10 && regex.test(value)) {
                          setEnteredValue(value);
                          if (value.length === 10) {
                            debouncedSearch(value);
                          } else if (value.length >= 2) {
                            debouncedSearch(value);
                          } else {
                            resetTableData();
                            setAllFoundCompanies([]);
                          }
                        }
                      } else if (searchByGst) {
                        regex = /^[a-zA-Z0-9]{0,15}$/;
                        if (value.length <= 15 && regex.test(value)) {
                          setEnteredValue(value);
                          if (value.length === 15) {
                            debouncedSearch(value);
                          } else if (value.length >= 2) {
                            debouncedSearch(value);
                          } else {
                            resetTableData();
                            setAllFoundCompanies([]);
                          }
                        }
                      } else {
                        setAllFoundCompanies([]);
                        resetTableData();
                      }
                    }}
                    {...(searchByPhone && {
                      type: "text",
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    })}
                  />
                </Box>
              )}
          </Box>
          {/* </Card> */}
          {allFoundCompanies && allFoundCompanies.length > 0 && (
            <SearchResultTable
              rows={allFoundCompanies}
              onRowClick={checkVCPClubbingLogic}
              showGstPan={!influencerTabSelected}
            />
          )}
        </Card>
        {allFoundCompanies.length === 0 &&
          (isLoadingAllBuyers ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height={300}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {allBuyers && allBuyers.length > 0 && (
                <Box
                  sx={{
                    position: "sticky",
                    top: { xs: "calc(88px + 56px)", md: "56px" },
                    zIndex: 999,
                  }}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {!isMobile && (
                      <Box>
                        <Typography variant="labelD">Select Below</Typography>
                      </Box>
                    )}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          zIndex: 1000,
                        }}>
                        {isMobile && (
                          <Typography variant="labelD">Select Below</Typography>
                        )}
                        <Tabs
                          value={activeTab}
                          onChange={(e, newValue) => setActiveTab(newValue)}
                          TabIndicatorProps={{ style: { display: "none" } }}
                          sx={{
                            minHeight: "auto",
                            "& .MuiTabs-flexContainer": {
                              gap: 1,
                            },
                            "& .MuiTabs-scroller": {
                              minHeight: "auto",
                            },
                          }}>
                          <CustomTab
                            value="My Network"
                            label="My Network"
                            active={activeTab === "My Network"}
                            variant="primary"
                            type="standard"
                            size={isMobile ? "small" : "medium"}
                          />
                          {allBuyers
                            .filter(
                              (tab) =>
                                tab.display_name !== "ACTIVE" &&
                                tab.display_name !== "DORMANT" &&
                                tab.display_name !== "My Network",
                            )
                            .map((section) => (
                              <CustomTab
                                key={section.display_name}
                                value={section.display_name}
                                label={section.display_name}
                                active={activeTab === section.display_name}
                                variant="primary"
                                type="standard"
                                tooltipText={section?.info_text || ""}
                                size={isMobile ? "small" : "medium"}
                              />
                            ))}
                        </Tabs>
                      </Box>
                      {getCurrentTabData() && (
                        <Box
                          sx={{ maxHeight: "60vh", overflowY: "auto", mt: 1 }}>
                          <TableContainer
                            variant="outlined"
                            sx={{
                              border: "none",
                              boxShadow: "none",
                              borderRadius: "8px",
                              overflowX: "auto",
                              maxHeight: "60vh",
                            }}>
                            <Table stickyHeader>
                              <TableHead>
                                <TableRow
                                  sx={{
                                    backgroundColor: "#E5E5E5",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    "& .MuiTableCell-root": {
                                      borderRight: "none",
                                      borderBottom: "1px solid #8C8C8C",
                                      backgroundColor: "#E5E5E5",
                                    },
                                  }}>
                                  <TableCell>
                                    <Typography
                                      variant="labelM"
                                      sx={{
                                        minWidth: { xs: "160px", md: "200px" },
                                      }}>
                                      Firm Name
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography
                                      variant="labelM"
                                      sx={{
                                        minWidth: { xs: "90px", md: "140px" },
                                      }}>
                                      Mobile Number
                                    </Typography>
                                  </TableCell>
                                  {influencerTabSelected && (
                                    <TableCell>
                                      <Typography
                                        variant="labelM"
                                        sx={{
                                          minWidth: { xs: "90px", md: "140px" },
                                        }}>
                                        Status
                                      </Typography>
                                    </TableCell>
                                  )}
                                  <TableCell sx={{ py: 2, px: 2 }}>
                                    <Typography
                                      variant="labelM"
                                      sx={{
                                        minWidth: { xs: "90px", md: "140px" },
                                      }}>
                                      Billing
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {getCurrentTabData().data &&
                                getCurrentTabData().data.length > 0 ? (
                                  getCurrentTabData().data.map((row, index) => (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        cursor: "pointer",
                                        backgroundColor:
                                          selectedUser?.company_phone_number ===
                                          row.company_phone_number
                                            ? "#995A000D"
                                            : "#0000",
                                        transition: "all 0.2s ease-in-out",
                                        "&:hover": {
                                          backgroundColor:
                                            selectedUser?.company_phone_number ===
                                            row.company_phone_number
                                              ? "#995A000D"
                                              : "#F49D3F0D",
                                        },
                                        boxShadow:
                                          selectedUser?.company_phone_number ===
                                          row.company_phone_number
                                            ? `inset 0 0 0 1px #995A00, inset 0 1px 0 0 #995A00`
                                            : `inset 0 1px 0 0 #D9D9D9`,
                                        "& .MuiTableCell-root": {
                                          borderBottom: "none",
                                          borderRight: "none",
                                        },
                                      }}
                                      onClick={() => {
                                        handleExistingShipToPartyClick(row);
                                      }}>
                                      <TableCell
                                        sx={{
                                          padding: { xs: 1, sm: 2 },
                                          maxWidth: 200,
                                          py: 2,
                                          px: 2,
                                        }}>
                                        <Typography variant="p3" noWrap>
                                          {row.company_name}
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          padding: { xs: 1, sm: 2 },
                                          py: 2,
                                          px: 2,
                                        }}>
                                        <Typography variant="p3">
                                          {row.company_phone_number}
                                        </Typography>
                                      </TableCell>
                                      {influencerTabSelected && (
                                        <TableCell
                                          sx={{
                                            padding: { xs: "10px", sm: 2 },
                                            py: 2,
                                            px: 2,
                                          }}>
                                          <StatusChip
                                            type="outlined"
                                            label={row.status}
                                            status={row.status}
                                            sx={{
                                              px: { xs: 0.5, sm: 2 },
                                              "& .MuiChip-label": {
                                                px: { xs: 0 },
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      )}
                                      <TableCell
                                        sx={{
                                          padding: { xs: 1, sm: 2 },
                                          width: { xs: "20%", sm: "auto" },
                                          py: 2,
                                          px: 2,
                                        }}>
                                        <Typography variant="p3">
                                          {row.billing || "-"}
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell
                                      colSpan={influencerTabSelected ? 4 : 3}
                                      align="center"
                                      sx={{
                                        padding: 4,
                                        borderBottom: "none",
                                        borderRight: "none",
                                        borderTop: "1px solid #D9D9D9",
                                      }}>
                                      <Typography variant="p2">
                                        No data found
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          ))}
      </Box>
    </>
  );
};

export default STPSelectionBase;